import { S as SvelteComponent, i as init, s as safe_not_equal, e as element, g as append, c as create_slot, u as update_slot, t as transition_in, h as transition_out, b as space, d as attr, f as insert, p as group_outros, q as check_outros, j as detach, W as destroy_each, A as onMount, F as binding_callbacks } from './common/index-80b6ced9.js';
import { c as createCommonjsModule } from './common/_commonjsHelpers-8c19dec8.js';

var build = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function compareStrings(sA, sB) {
    return sA > sB ? 1 : sA < sB ? -1 : 0;
}
exports.compareStrings = compareStrings;
function compareNumbers(sA, sB) {
    return sA - sB;
}
exports.compareNumbers = compareNumbers;
function reverse(r) {
    return -r;
}
exports.reverse = reverse;
function compareStringsCaseInsensitive(sA, sB) {
    return sA.localeCompare(sB, undefined, {
        sensitivity: 'base',
    });
}
exports.compareStringsCaseInsensitive = compareStringsCaseInsensitive;
function sortFunction(gen) {
    return (a, b) => {
        for (let comp of gen(a, b)) {
            if (comp) {
                return comp;
            }
        }
        return 0;
    };
}
exports.sortFunction = sortFunction;

});

/* node_modules/svelte-tablesort/TableSort.svelte generated by Svelte v3.37.0 */

function add_css() {
	var style = element("style");
	style.id = "svelte-1h7c4zv-style";
	style.textContent = "thead.svelte-1h7c4zv th.sortable{cursor:pointer;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}";
	append(document.head, style);
}

const get_tfoot_slot_changes = dirty => ({});
const get_tfoot_slot_context = ctx => ({});

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[11] = list[i];
	return child_ctx;
}

const get_tbody_slot_changes = dirty => ({ item: dirty & /*sortedItems*/ 4 });
const get_tbody_slot_context = ctx => ({ item: /*item*/ ctx[11] });
const get_thead_slot_changes = dirty => ({});
const get_thead_slot_context = ctx => ({});

// (111:8) {#each sortedItems as item}
function create_each_block(ctx) {
	let current;
	const tbody_slot_template = /*#slots*/ ctx[6].tbody;
	const tbody_slot = create_slot(tbody_slot_template, ctx, /*$$scope*/ ctx[5], get_tbody_slot_context);

	return {
		c() {
			if (tbody_slot) tbody_slot.c();
		},
		m(target, anchor) {
			if (tbody_slot) {
				tbody_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (tbody_slot) {
				if (tbody_slot.p && dirty & /*$$scope, sortedItems*/ 36) {
					update_slot(tbody_slot, tbody_slot_template, ctx, /*$$scope*/ ctx[5], dirty, get_tbody_slot_changes, get_tbody_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(tbody_slot, local);
			current = true;
		},
		o(local) {
			transition_out(tbody_slot, local);
			current = false;
		},
		d(detaching) {
			if (tbody_slot) tbody_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let table;
	let thead_1;
	let t0;
	let tbody;
	let t1;
	let tfoot;
	let table_class_value;
	let current;
	const thead_slot_template = /*#slots*/ ctx[6].thead;
	const thead_slot = create_slot(thead_slot_template, ctx, /*$$scope*/ ctx[5], get_thead_slot_context);
	let each_value = /*sortedItems*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	const tfoot_slot_template = /*#slots*/ ctx[6].tfoot;
	const tfoot_slot = create_slot(tfoot_slot_template, ctx, /*$$scope*/ ctx[5], get_tfoot_slot_context);

	return {
		c() {
			table = element("table");
			thead_1 = element("thead");
			if (thead_slot) thead_slot.c();
			t0 = space();
			tbody = element("tbody");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			tfoot = element("tfoot");
			if (tfoot_slot) tfoot_slot.c();
			attr(thead_1, "class", "svelte-1h7c4zv");
			attr(table, "class", table_class_value = "" + (CLASSNAME_TABLE + " " + /*className*/ ctx[0]));
		},
		m(target, anchor) {
			insert(target, table, anchor);
			append(table, thead_1);

			if (thead_slot) {
				thead_slot.m(thead_1, null);
			}

			/*thead_1_binding*/ ctx[7](thead_1);
			append(table, t0);
			append(table, tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(tbody, null);
			}

			append(table, t1);
			append(table, tfoot);

			if (tfoot_slot) {
				tfoot_slot.m(tfoot, null);
			}

			current = true;
		},
		p(ctx, [dirty]) {
			if (thead_slot) {
				if (thead_slot.p && dirty & /*$$scope*/ 32) {
					update_slot(thead_slot, thead_slot_template, ctx, /*$$scope*/ ctx[5], dirty, get_thead_slot_changes, get_thead_slot_context);
				}
			}

			if (dirty & /*$$scope, sortedItems*/ 36) {
				each_value = /*sortedItems*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(tbody, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (tfoot_slot) {
				if (tfoot_slot.p && dirty & /*$$scope*/ 32) {
					update_slot(tfoot_slot, tfoot_slot_template, ctx, /*$$scope*/ ctx[5], dirty, get_tfoot_slot_changes, get_tfoot_slot_context);
				}
			}

			if (!current || dirty & /*className*/ 1 && table_class_value !== (table_class_value = "" + (CLASSNAME_TABLE + " " + /*className*/ ctx[0]))) {
				attr(table, "class", table_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(thead_slot, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(tfoot_slot, local);
			current = true;
		},
		o(local) {
			transition_out(thead_slot, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(tfoot_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(table);
			if (thead_slot) thead_slot.d(detaching);
			/*thead_1_binding*/ ctx[7](null);
			destroy_each(each_blocks, detaching);
			if (tfoot_slot) tfoot_slot.d(detaching);
		}
	};
}

const CLASSNAME_TABLE = "tablesort";
const CLASSNAME_SORTABLE = "sortable";
const CLASSNAME_ASC = "ascending";
const CLASSNAME_DESC = "descending";

function instance($$self, $$props, $$invalidate) {
	let sortedItems;
	let { $$slots: slots = {}, $$scope } = $$props;
	let { items } = $$props;
	let { class: className = "" } = $$props;
	let thead;
	let sortOrder = [[]];

	const sorted = function (arr, sortOrder) {
		arr.sort(build.sortFunction(function* (a, b) {
			for (let [fieldName, r] of sortOrder) {
				const reverse = r === 0 ? 1 : -1;

				if (typeof a[fieldName] === "number") {
					yield reverse * build.compareNumbers(a[fieldName], b[fieldName]);
				} else {
					yield reverse * build.compareStrings(a[fieldName], b[fieldName]);
				}
			}
		}));

		return arr;
	};

	function updateSortOrder(th, push) {
		const fieldName = th.dataset.sort;

		if (push) {
			if (sortOrder[sortOrder.length - 1][0] === fieldName) {
				$$invalidate(4, sortOrder[sortOrder.length - 1] = [fieldName, (sortOrder[sortOrder.length - 1][1] + 1) % 2], sortOrder);
			} else {
				$$invalidate(4, sortOrder = [...sortOrder, [fieldName, 0]]);
			}
		} else {
			if (sortOrder.length === 1 && sortOrder[0][0] === fieldName) {
				$$invalidate(4, sortOrder[0] = [fieldName, (sortOrder[0][1] + 1) % 2], sortOrder);
			} else {
				resetClasses();
				$$invalidate(4, sortOrder = [[fieldName, 0]]);
			}
		}

		th.className = CLASSNAME_SORTABLE + " " + (sortOrder[sortOrder.length - 1][1]
		? CLASSNAME_DESC
		: CLASSNAME_ASC);
	}

	function resetClasses() {
		const th = thead.getElementsByTagName("th");

		for (let i = 0; i < th.length; i++) {
			if (th[i].dataset.sort) {
				th[i].className = CLASSNAME_SORTABLE;
			}
		}
	}

	onMount(() => {
		const th = thead.getElementsByTagName("th");

		for (let i = 0; i < th.length; i++) {
			if (th[i].dataset.sort) {
				th[i].className = CLASSNAME_SORTABLE;
				th[i].onclick = event => updateSortOrder(th[i], event.shiftKey);
			}

			if (th[i].dataset.sortInitial === "descending") {
				th[i].className = CLASSNAME_SORTABLE + " " + CLASSNAME_DESC;
				$$invalidate(4, sortOrder = [...sortOrder, [th[i].dataset.sort, 1]]);
			} else if (th[i].dataset.sortInitial != undefined) {
				th[i].className = CLASSNAME_SORTABLE + " " + CLASSNAME_ASC;
				$$invalidate(4, sortOrder = [...sortOrder, [th[i].dataset.sort, 0]]);
			}
		}
	});

	function thead_1_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			thead = $$value;
			$$invalidate(1, thead);
		});
	}

	$$self.$$set = $$props => {
		if ("items" in $$props) $$invalidate(3, items = $$props.items);
		if ("class" in $$props) $$invalidate(0, className = $$props.class);
		if ("$$scope" in $$props) $$invalidate(5, $$scope = $$props.$$scope);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*items, sortOrder*/ 24) {
			 $$invalidate(2, sortedItems = sorted([...items], sortOrder));
		}
	};

	return [
		className,
		thead,
		sortedItems,
		items,
		sortOrder,
		$$scope,
		slots,
		thead_1_binding
	];
}

class TableSort extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1h7c4zv-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { items: 3, class: 0 });
	}
}

export { TableSort };
